/** Google / account photo URL for avatars (session user object). */
export function getUserAvatarUrl(user, fallback) {
  const url =
    user?.google_avatar_url ||
    user?.google_photo_url ||
    user?.google_picture ||
    user?.picture ||
    user?.photo_url ||
    user?.avatar_url ||
    "";
  const trimmed = String(url || "").trim();
  return trimmed || fallback;
}

export function getUserDisplayName(user) {
  const name = String(user?.full_name || user?.username || "").trim();
  return name || "User";
}

/** Props for MUI Avatar when loading external URLs (e.g. Google). */
export const userAvatarImgProps = {
  referrerPolicy: "no-referrer",
};
